<template>
  <v-card elevation="0">
    <v-toolbar dark flat color="green">
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-col lg12>
        <v-form ref="lectureForm" name="lectureForm">
          <v-col>
            <v-col lg12>
              <v-text-field
                v-model="lecture.name"
                label="Название"
                name="name"
                :rules="rules.required"
                outlined
              >
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="lecture.duration"
                type="number"
                label="Продолжительность"
                name="duration"
                :rules="rules.required"
                outlined
              >
              </v-text-field>
            </v-col>
            <v-col>
              <v-textarea
                v-model="lecture.description"
                label="Краткое описание"
                name="description"
                :rules="rules.required"
                outlined
              >
              </v-textarea>
            </v-col>
            <!--          Dates-->
            <v-col>
              <v-row row>
                <v-col lg6>
                  <v-menu
                    ref="dateMenu"
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="date" prepend-icon="event" readonly v-on="on" outlined>
                        <template v-slot:label>
                          <span>{{ dateLabel }}</span>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="date" locale="ru-ru" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dateMenu = false">Закрыть</v-btn>
                      <v-btn text color="primary" @click="$refs.dateMenu.save(date)">
                        Выбрать
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col lg6>
                  <v-menu
                    ref="timeMenu"
                    v-model="timeMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="time"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="time"
                        prepend-icon="mdi-clock"
                        readonly
                        label="Выберите время"
                        v-on="on"
                        outlined
                      >
                      </v-text-field>
                    </template>
                    <v-time-picker v-model="time" locale="ru-ru" scrollable format="24hr">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="timeMenu = false">Закрыть</v-btn>
                      <v-btn text color="primary" @click="$refs.timeMenu.save(time)">
                        Выбрать
                      </v-btn>
                    </v-time-picker>
                  </v-menu>
                  <input hidden v-model="lectureStartDate" name="start_date" />
                  <input hidden v-model="lecture.course_id" name="course_id" />
                </v-col>
              </v-row>
            </v-col>
            <!--          Teacher-->
            <v-col>
              <TeacherSelect :teacher="lecture.teacher_id" @teacher-id-selected="teacherSelected">
              </TeacherSelect>
            </v-col>
          </v-col>
          <v-col>
            <v-card v-if="isEdit" elevation="0">
              <v-toolbar dark flat color="light-blue">
                <v-toolbar-title>Материалы лекции</v-toolbar-title>
              </v-toolbar>
              <v-list three-line>
                <v-list-item
                  v-for="item in lecture.materials"
                  :key="item.id"
                  @click="editMaterial(item.id)"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                    <v-list-item-subtitle v-text="displayKind(item.kind)"></v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action-text>
                    <v-btn icon big color="error" @click.stop="removeMaterial(item.id)">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-list-item-action-text>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-dialog
                      max-width="600px"
                      hide-overlay
                      transition="dialog-bottom-transition"
                      v-model="materialDialog"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="text-center"
                          dark
                          outlined
                          color="light-blue"
                          v-bind="attrs"
                          v-on="on"
                        >
                          добавить материал в лекцию
                          <!--                    <v-icon dark>add</v-icon>-->
                        </v-btn>
                      </template>
                      <v-card>
                        <LectureMaterial
                          :reset-on-create="true"
                          :lecture-id="lecture.id"
                          @material-update="materialUpdate"
                          @cancel="materialDialog = false"
                        ></LectureMaterial>
                      </v-card>
                    </v-dialog>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card elevation="0">
              <v-toolbar dark flat color="lime">
                <v-toolbar-title>Тест</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <Poll v-if="lecture.id" :id="lecture.id" :type="pollType"></Poll>
              </v-card-text>
            </v-card>
          </v-col>
          <v-row>
            <v-col lg6>
              <v-btn color="green" dark @click="save">Сохранить</v-btn>
            </v-col>
            <v-col lg6 align="right">
              <v-btn right color="warning" outlined @click="$emit('cancel')">Закрыть</v-btn>
            </v-col>
          </v-row>
        </v-form>
        <v-dialog
          max-width="800px"
          hide-overlay
          transition="dialog-bottom-transition"
          v-model="editMaterialDialog"
        >
          <LectureMaterial
            :lecture-id="lecture.id"
            :material-id="editMaterialId"
            @material-update="materialUpdate"
            @cancel="editMaterialDialog = false"
          >
          </LectureMaterial>
        </v-dialog>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import ckeditorMixin from '@/mixins/ckeditor'
import firmMixins from '@/mixins/forms'
import TeacherSelect from '@/components/hps/TeacherSelect'
import LectureMaterial from '@/components/hps/LectureMaterial'
import Poll from '@/components/polls/Poll'
import hps from '@/utils/hps'
import { POLL_OBJECTS } from '@/api/polls'

export default {
  name: 'Lecture',
  components: { LectureMaterial, TeacherSelect, Poll },
  mixins: [ckeditorMixin, firmMixins],
  props: {
    courseId: { type: String, required: false, default: '' },
    lectureId: { type: String, required: false, default: '' },
  },
  data() {
    return {
      pollType: POLL_OBJECTS.HPS_LECTURE,
      time: '',
      date: '',
      dateMenu: false,
      timeMenu: false,
      materialDialog: false,
      editMaterialDialog: false,
      editMaterialId: 0,
      lecture: {
        id: '',
        name: '',
        start_date: '',
        description: '',
        course_id: '',
        duration: '',
        teacher_id: '',
        materials: [],
      },
    }
  },
  computed: {
    isEdit() {
      return !!this.lectureId
    },
    title() {
      const dateFormat = this.$moment(this.lecture.start_date)
      let s = 'Лекция'
      if (this.lecture.name) {
        s += ` "${this.lecture.name}"`
      }
      if (dateFormat.isValid()) {
        s += ` ${dateFormat.format('LL')}`
      }
      return s
    },
    dateLabel() {
      const aDate = this.$moment(this.lecture.start_date)
      if (!aDate.isValid()) {
        return 'Выберите дату'
      }
      const strDate = aDate.format('LL')
      let s = `${strDate}`
      return s
    },
    lectureStartDate() {
      const date = this.$moment(`${this.date}T${this.time}`)
      if (date.isValid()) {
        return date.format()
      }
      return ''
    },
  },
  watch: {
    courseId() {
      this.lecture.course_id = this.courseId
    },
    lectureId() {
      this.lecture.id = this.lectureId
      this.getLectureData()
    },
  },
  mounted() {
    this.lecture.course_id = this.courseId
    this.lecture.id = this.lectureId
    if (this.isEdit) {
      this.getLectureData()
    }
  },
  methods: {
    editMaterial(id) {
      this.editMaterialId = id
      this.editMaterialDialog = true
    },
    displayKind(kind) {
      return hps.material_kinds[kind]
    },
    teacherSelected(id) {
      this.lecture.teacher_id = id
    },
    imageSelected(e) {
      this.lecture.image = e
    },
    materialUpdate() {
      this.getMaterialsData()
    },
    getMaterialsData() {
      this.axios({
        url: `/v1/hps/lectures/${this.lecture.id}/materials`,
        method: 'get',
      })
        .then((resp) => {
          this.lecture.materials = resp.data
          this.$emit('materials-update', this.lecture)
        })
        .catch((err) => {
          this.$log.error('get lecture materials', err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    getLectureData() {
      this.axios({
        url: `/v1/hps/lectures/${this.lecture.id}`,
        method: 'get',
      })
        .then((resp) => {
          this.lecture = resp.data
          this.time = this.$moment(this.lecture.start_date).format('HH:mm')
          this.date = this.$moment(this.lecture.start_date).format('YYYY-MM-DD')
          this.$emit('lecture-update', this.lecture)
        })
        .catch((err) => {
          this.$log.error('get lecture', err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    updateLecture() {
      const d = new FormData(this.$refs.lectureForm.$el)
      this.axios({
        url: `/v1/hps/lectures/${this.lecture.id}`,
        method: 'post',
        data: d,
        config: { headers: { 'content-type': 'multipart/form-data' } },
      })
        .then((resp) => {
          this.lecture = resp.data
          this.$emit('lecture-update', this.lecture)
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    removeMaterial(id) {
      this.axios({
        url: `/v1/hps/materials/${id}`,
        method: 'delete',
      })
        .then((resp) => {
          this.$emit('lecture-material-delete', this.lecture)
          this.showSnackbar('Удалено', 'green')
          this.getMaterialsData()
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    save() {
      if (this.isEdit) {
        this.updateLecture()
        return
      }
      if (!this.$refs.lectureForm.validate()) {
        this.showSnackbar('Исправьте ошибки', 'error')
        return
      }
      const d = new FormData(this.$refs.lectureForm.$el)
      this.axios({
        url: '/v1/hps/lectures',
        method: 'post',
        data: d,
        config: { headers: { 'content-type': 'multipart/form-data' } },
      })
        .then((resp) => {
          this.lecture = resp.data
          this.$emit('lecture-update', this.lecture)
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.showSnackbar(err.response.data, 'error')
        })
    },
  },
}
</script>
